import axiosInstance from '../services/AxiosInstance';

export const getMerchantPayout = (getData) => {
  return axiosInstance.get("payouts/list", {
    params: getData,
  });
};

export const getMerchantTransactionData = (transactionId) => {
  return axiosInstance.get(`payouts/view/${transactionId}`);
};


export const addMerchantPayout = (data) => {
  return axiosInstance.post("payouts/create", data);
};

export const addMerchantSinglePayout = (data) => {
  return axiosInstance.post("payouts/single", data);
};

export const getMerchantPayoutCount = (data) => {
  return axiosInstance.get("payouts/overview", {
    params: data,
  });
};

export const getMerchantBulkPayoutCount = (data) => {
  return axiosInstance.get("bulk-payouts/overview", {
    params: data,
  });
};

export const getIndiviudalMerchantPayoutCount = (id, data) => {
  return axiosInstance.get(`payouts/overview-merchant/${id}`, data);
};

export const getLienandDebitCount = (getData) => {
  return axiosInstance.get(`payouts/debit-merchant-list-count`, {
    params: getData,
  });
};

export const getMerchantPayoutList = (getData) => {
  return axiosInstance.get("payouts/list", {
    params: getData,
  });
};

export const getMerchantBulkPayoutList = (getData) => {
  return axiosInstance.get("bulk-payouts", {
    params: getData,
  });
};

export const getMerchantBulkPayoutDetails = (getData) => {
  return axiosInstance.get(`bulk-payouts/details/${getData}`);
};


export const getMerchantBulkPayoutEntries = (getData) => {
  return axiosInstance.post("bulk-payouts/list/histories", getData);
};


export const getMerchantBulkPayoutTransactionEntries = (getData) => {
  return axiosInstance.post("bulk-payouts/list/transactions", getData);
};

export const updateBulkTransferStatus = (getData) => {
  return axiosInstance.post("bulk-payouts/update-status", getData);
};

export const updateMerchantPayout = (id, data) => {
  return axiosInstance.put(`payouts/update/${id}`, data);
};

export const updateMerchantDebitBalance = (data) => {
  return axiosInstance.post(`payouts/debit-merchant`, data);
};

export const getSingleStatus = (data) => {
  return axiosInstance.post(`payouts/single-status`, data);
};

export const uploadBulkPayoutCSV = (formData) => {
  return axiosInstance.post("bulk-payouts/upload-csv", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


export const fetchMerchantPayoutById = async (id) => {
    const response = await axiosInstance.get(`payouts/show/${id}`);
    return response.data;
};
